import classNames from "classnames";
import { Block } from "./Block";
import type { BlockProps } from "./Block";

interface SquareWithBorderProps extends BlockProps {
  className?: string;
}

export const SquareWithBorder = ({
  className,
  ...rest
}: SquareWithBorderProps) => (
  <Block
    className={classNames("border-tertiary size-5 rounded border-2", className)}
    {...rest}
  />
);
